export default __webpack_public_path__ + "static/media/19-min.98cb01f4.jpg";